import createVueApp from '@/common/create_app'

Styxie.Initializers.MlapSettingsBing = {
  show: async(props) => {
    const { default: BingSettings } = await import('@/vue_widgets/mlap/settings/bing/index.vue')
    createVueApp(BingSettings, { props })
  }
}
